import pulse from '@finn-no/pulse-sdk';
import type { PrepackageSearchState } from '../../types';
import { buildPrepackageTrackingItem } from './buildPrepackageTrackingItem';

export const trackPrepackageSearchClick = (position: string, state: PrepackageSearchState, numHits: number): void => {
    pulse.trackEvent({
        type: 'Click',
        intent: 'Search',
        name: 'Search prepackage',
        object: {
            // @ts-ignore id can only be string
            id: undefined,
            type: 'UIElement',
            elementType: 'Button',
            position,
            numHits,
            items: [buildPrepackageTrackingItem(state)],
        },
        target: {
            id: '/reise/pakkereiser',
            type: 'Listing',
        },
        vertical: {
            name: 'travel',
            subVertical: 'prepackage',
        },
    });
};
